export default __webpack_public_path__ + "static/media/capaBolos1.bd53e951.jpg";